import { get, isNil } from "lodash";

const SCREEN_FRAME_ATTRIBUTE = "data-krs-screen";
const FRAME_AWARE_TYPES = [
  "Element",
  "HTMLElement",
  "SVGElement",
  "Node",
  "ShadowRoot",
];
const isInstance = Function.prototype[Symbol.hasInstance];

let accepting = false;

const read = (target, path) => {
  try {
    return get(target, path);
  } catch (_error) {
    return null;
  }
};

const isScreenFrameNode = (node) => {
  const ownerDocument = read(node, "ownerDocument");
  if (isNil(ownerDocument) || ownerDocument === document) return false;
  const root = read(ownerDocument, "documentElement");
  if (isNil(root)) return false;
  try {
    return root.hasAttribute(SCREEN_FRAME_ATTRIBUTE);
  } catch (_error) {
    return false;
  }
};

const frameInstance = (node, typeName) => {
  const frameType = read(node, ["ownerDocument", "defaultView", typeName]);
  return !isNil(frameType) && isInstance.call(frameType, node);
};

const acceptScreenFrameNodes = () => {
  if (accepting) return;
  accepting = true;
  for (const name of FRAME_AWARE_TYPES) {
    if (isNil(window[name])) continue;
    Object.defineProperty(window[name], Symbol.hasInstance, {
      configurable: true,
      value(node) {
        if (isInstance.call(this, node)) return true;
        try {
          return isScreenFrameNode(node) && frameInstance(node, this.name);
        } catch (_error) {
          return false;
        }
      },
    });
  }
};

export const adoptScreenFrame = (doc) => {
  acceptScreenFrameNodes();
  doc.documentElement.setAttribute(SCREEN_FRAME_ATTRIBUTE, "");
};
